<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col class="m-0 p-0">
          <form @submit.prevent="setQuestion">
            <b-overlay :show="sent" rounded="sm">
              <b-card bg-variant="light" class="m-0 p-0">
                <b-form-group class="mb-0">
                  <div v-if="uploaded" class="alert alert-success p-3">
                    Question Uploaded
                  </div>
                  <b-form-group label="Select category" label-for="category">
                    <b-form-select
                      id="category"
                      :options="categoryarray"
                      v-model="question.category"
                      @change="categoryChanged"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select category--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="sameName != 'Yes'"
                    label="Institution/University"
                    label-for="selectinstitution"
                  >
                    <b-form-select
                      id="selectinstitution"
                      class="form-inp"
                      :options="institutionsarray"
                      v-model="question.institution"
                      @change="institutionChanged"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select Institution--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="nested-form-group"
                    v-if="
                      structure == 'Section' && question.institution != null
                    "
                    label="Select Level"
                    label-for="institution"
                  >
                    <b-form-select
                      v-model="question.level"
                      @change="chgCourses"
                      :options="levelarray"
                    >
                      <b-form-select-option
                        v-if="plan != 'Premium'"
                        value="null"
                        >--Select Level--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="nested-form-group"
                    v-if="
                      structure == 'Section' &&
                        question.institution != null &&
                        question.level != null
                    "
                    label="Select Course"
                    label-for="institution"
                  >
                    <b-form-select
                      v-model="question.course"
                      @change="chgSection"
                      :options="coursesarray"
                    >
                      <b-form-select-option value="null"
                        >--Select Course--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="nested-form-group"
                    v-if="
                      structure == 'Section' &&
                        question.institution != null &&
                        question.level != null &&
                        question.course != null
                    "
                    label="Select Section"
                    label-for="institution"
                  >
                    <b-form-select
                      v-model="question.section"
                      :options="sectionarray"
                    >
                      <b-form-select-option value="null"
                        >--Select Section--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="structure == 'Subject'"
                    label="Select Subject"
                    label-for="selectsubject"
                  >
                    <b-form-select
                      id="selectsbuject"
                      class="form-inp"
                      :options="subjectsarray"
                      v-model="question.subject"
                      label="Select Subject"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select Subject--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="question.category != null"
                    label="Any Image Attachment to Question?"
                  >
                    <b-form-radio
                      v-model="question.isAttachment"
                      name="attach"
                      value="Yes"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isAttachment"
                      name="attach"
                      value="No"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>
                  <b-overlay :show="uploadingqimage">
                    <template #overlay>
                      <div class="text-center">
                        <b-icon-file-image
                          font-scale="3"
                          animation="throb"
                        ></b-icon-file-image>
                        <p>Uploading Image...</p>
                      </div>
                    </template>
                    <b-form-group>
                      <b-form-file
                        v-model="question.attachmentlink"
                        v-if="question.isAttachment == 'Yes' || question.isAttachment"
                        ref="file"
                        placeholder="Choose a file or drop it here"
                        drop-placeholder="Drop File here..."
                        @input="handleImage"
                      ></b-form-file>
                    </b-form-group>
                    <img
                      :src="attachmentfiles"
                      v-if="question.isAttachment == 'Yes' || question.isAttachment"
                      class="image-attachment"
                    />
                  </b-overlay>

                  <b-form-group
                    v-if="question.category != null"
                    label="Any Inline Image Attachement to Question?"
                  >
                    <b-form-radio
                      v-model="inlineattachment"
                      name="inlineattach"
                      value="Yes"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="inlineattachment"
                      name="inlineattach"
                      value="No"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <b-modal centered id="inlinemodal" ok-only button-size="lg">
                    <div>
                      <p>Image Uploaded Successfully. Copy the Link below</p>
                      <code class="p-2 m-2 w-100 copyinline" id="copyinline">
                        <p class="copytext">{{ inlineattachmentfile }}</p>
                        <b-icon-folder
                          @click="copylink()"
                          class="copyicon"
                          font-scale="2"
                        ></b-icon-folder>
                      </code>
                      <p>And paste in the Image link field.</p>
                      <b-form-input
                        @input="copynow()"
                        v-model="copytext"
                        class="copier"
                        id="copier"
                      ></b-form-input>
                    </div>
                  </b-modal>

                  <b-overlay :show="uploadinginlineimage">
                    <template #overlay>
                      <div class="text-center">
                        <b-icon-file-image
                          font-scale="3"
                          animation="throb"
                        ></b-icon-file-image>
                        <p>Uploading Image...</p>
                      </div>
                    </template>
                    <b-form-group
                      v-if="inlineattachment == 'Yes'"
                      label="Choose the file and Drop it here.  Then Copy the link after Uploading and Paste in the Link Field of the Image Property"
                    >
                      <b-form-file
                        v-model="question.attachmentlink"
                        v-if="inlineattachment == 'Yes'"
                        ref="inlinefile"
                        placeholder="Choose a file or drop it here."
                        drop-placeholder="Drop File here..."
                        @input="handleInlineImage"
                      ></b-form-file>
                    </b-form-group>
                    <img
                      :src="inlineattachmentfile"
                      v-if="inlineattachment == 'Yes'"
                      class="image-attachment"
                    />
                  </b-overlay>

                  <b-form-group label="Is there a Passage to be read?">
                    <b-form-radio
                      v-model="question.isPassage"
                      name="ispassage"
                      value="Yes"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isPassage"
                      name="ispassage"
                      value="No"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    label="Passage to read(if any)"
                    label-for="passage"
                    v-if="question.isPassage == 'Yes' || question.isPassage"
                  >
                    <vue2-tinymce-editor
                      v-model="question.passage"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group
                    label="Select Question Structure"
                    label-for="correct"
                  >
                    <b-form-select
                      id="correct"
                      :options="structureoptions"
                      v-model="question.structure"
                      required
                    />
                  </b-form-group>

                  <b-form-group label="Input Question" label-for="question">
                    <vue2-tinymce-editor
                      v-model="question.question"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option A" label-for="optiona">
                    <vue2-tinymce-editor
                      v-model="question.optionA"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option B" label-for="optionb">
                    <vue2-tinymce-editor
                      v-model="question.optionB"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option C" label-for="optionc">
                    <vue2-tinymce-editor
                      v-model="question.optionC"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option D" label-for="optiond">
                    <vue2-tinymce-editor
                      v-model="question.optionD"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option E (Optional)" label-for="optione">
                    <vue2-tinymce-editor
                      v-model="question.optionE"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Correct Option" label-for="correct">
                    <b-form-select
                      id="correct"
                      :options="options"
                      v-model="question.correct"
                      required
                    />
                  </b-form-group>

                  <div v-if="question.structure == 'OEQ'">
                    <b-form-group label="OEQ Text Answer">
                      <b-form-input
                        v-model="question.oeqanswer"
                        placeholder="Answer"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <b-form-group label="Is there a Solution?">
                    <b-form-radio
                      v-model="question.isSolution"
                      name="solatt"
                      value="Yes"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isSolution"
                      name="solatt"
                      value="No"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>
                  <b-form-group
                    v-if="question.isSolution == 'Yes' || question.isSolution"
                    label="Solution Type"
                  >
                    <b-form-select v-model="question.solutiontype">
                      <b-form-select-option value="null"
                        >--Solution Type--</b-form-select-option
                      >
                      <b-form-select-option value="Text"
                        >Text</b-form-select-option
                      >
                      <b-form-select-option value="Image"
                        >Image</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group
                    v-if="
                      question.solutiontype == 'Text' &&
                        question.isSolution == 'Yes' || question.isSolution
                    "
                    label="Solution"
                    label-for="solution"
                  >
                    <vue2-tinymce-editor
                      v-model="question.solution"
                    ></vue2-tinymce-editor>
                  </b-form-group>
                  <b-overlay :show="uploadingqimage">
                    <template #overlay>
                      <div class="text-center">
                        <b-icon-file-image
                          font-scale="3"
                          animation="throb"
                        ></b-icon-file-image>
                        <p>Uploading Image...</p>
                      </div>
                    </template>
                    <b-form-group
                      v-if="
                        question.solutiontype == 'Image' &&
                          question.isSolution == 'Yes' || question.isSolution
                      "
                      label="Solution Image"
                    >
                      <b-form-file
                        v-model="solutionlink"
                        ref="sfile"
                        placeholder="Choose a file or drop it here"
                        drop-placeholder="Drop File here..."
                        @input="handleSolutionimage"
                      ></b-form-file>
                    </b-form-group>
                    <img
                      :src="solutionlink"
                      v-if="
                        question.solutiontype == 'Image' &&
                          question.isSolution == 'Yes' || question.isSolution
                      "
                      class="image-attachment mb-3"
                    />
                  </b-overlay>

                  <b-form-group label="Topic Reference">
                    <b-form-input
                      v-model="question.topicref"
                      placeholder="Topic Reference"
                    ></b-form-input>
                  </b-form-group>

                  <div v-if="uploaded" class="alert alert-success p-3">
                    Question Uploaded
                  </div>

                  <b-row>
                    <b-col></b-col>
                    <b-col md="6">
                      <b-form-group>
                        <b-overlay
                          :show="uploading"
                          rounded
                          opacity="0.6"
                          spinner-small
                          spinner-variant="primary"
                          class=""
                        >
                          <b-button
                            :disabled="empties"
                            type="submit"
                            class="btn-sub p-1 w-100"
                            variant="success"
                          >
                            Save Changes
                          </b-button>
                        </b-overlay>
                      </b-form-group>
                    </b-col>
                    <b-col> </b-col>
                  </b-row>
                </b-form-group>
              </b-card>
            </b-overlay>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";
import axios from "axios";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
  components: {
    Vue2TinymceEditor
  },
  data() {
    return {
      inlineattachmentfile: "",
      inlineattachment: "No",
      copytext: "",
      showcopy: false,
      leaving: false,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          {
            script: "super"
          },
          {
            script: "sub"
          }
        ],
        ["code-block"],
        ["formula"]
      ],
      dismissCountDown: 60,
      subjectsarray: [],
      categoryarray: [],
      options: [
        {
          value: null,
          text: "--Choose Correct Option--"
        },
        {
          value: "A",
          text: "A"
        },
        {
          value: "B",
          text: "B"
        },
        {
          value: "C",
          text: "C"
        },
        {
          value: "D",
          text: "D"
        },
        {
          value: "E",
          text: "E"
        }
      ],
      structureoptions: [
        {
          value: null,
          text: "--Choose question structure--"
        },
        {
          value: "MCQ",
          text: "MCQ (Multiple Choice Questions)"
        },
        {
          value: "OEQ",
          text: "OEQ (Open-ended Questions)"
        }
      ],
      levelarray: [],
      coursesarray: [],
      sectionarray: [],
      scholarshiptypearr: [],
      institutionsarray: [],
      question: this.getForm(),
      sent: false,
      uploading: false,
      questionupdated: false,
      filelink: "",
      uploadingqimage: false,
      uploadinginlineimage: false,
      attachmentfiles: "",
      solutionlink: "",
      structure: "",
      org: "",
      sameName: ""
    };
  },

  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchInstitutions");
    store.dispatch("admin/fetchQuestion");
    next();
  },
  created() {
    this.setImageDirectory("questions");
    if (!this.loggedin) {
      this.$router.push({
        name: "login"
      });
    }
    if (this.details.clearance == "Normal") {
      this.$router.push({
        name: "welcome"
      });
    }
    this.org = this.details.clearance_organization;

    this.question.organization = this.org;
    let tabi = this.allinsti
      .filter(
        x =>
          x.category == this.retrievedquestion.category &&
          x.name == this.retrievedquestion.institution &&
          x.organization_name == this.org
      )
      .map(x => x.structure);
    this.structure = tabi[0];
    // let tabi = this.Categories.filter(
    //     (x) => x.organization_name == this.org && x.name == this.retrievedquestion.category
    // ).map((x) => x.structure);
    // this.structure = tabi[0];

    let sameName = this.Categories.filter(
      x =>
        x.organization_name == this.org &&
        x.name == this.retrievedquestion.category
    ).map(x => x.sameName);
    this.sameName = sameName[0];

    let inst = this.allinsti.map(x => x.name);
    let typesarr = this.Categories.map(x => x.name);
    this.categoryarray = typesarr;

    this.institutionsarray = inst;

    let categoryinstitution = "";
    // alert(this.sameName)
    if (this.structure == "Section") {
      let levell = this.allinsti
        .filter(
          x =>
            x.category == this.retrievedquestion.category &&
            x.name == this.retrievedquestion.institution
        )
        .map(x => x.levels_config);
      //console.log(JSON.parse(levell))
      let reallevell = JSON.parse(levell);

      this.levelarray = reallevell.map(x => x.name);
      categoryinstitution = this.retrievedquestion.institution;

      // let levell = this.allinsti.filter((x) => x.category == this.retrievedquestion.category && x.name == this.retrievedquestion.institution).map((x) => x.levels_config);

      // let reallevell = JSON.parse(levell)

      // // Get the Chosen Level exact config Array
      let config = reallevell
        .filter(x => x.name == this.retrievedquestion.level)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config[0]
        .filter(x => x.name == "courses")
        .map(x => x.values);

      // Inject this Array into the general courses Array for Selection
      this.coursesarray = courses[0];

      let sections = config[0]
        .filter(x => x.name == "sectionsperc")
        .map(x => x.values);

      let courseindex = this.coursesarray.indexOf(
        this.retrievedquestion.course
      );
      let nsections = sections[0][courseindex];
      let sectarr = Array();

      for (let i = 0; i < nsections; i++) {
        let alpha = Array(
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K"
        );
        sectarr.push("Section " + alpha[i]);
      }

      this.sectionarray = sectarr;
    } else {
      let subbb = this.allinsti
        .filter(x => x.name == this.retrievedquestion.institution)
        .map(x => x.subjects_offered);
      this.subjectsarray = JSON.parse(subbb);

      if (this.sameName == "Yes") {
        categoryinstitution = this.retrievedquestion.category;

        let subbb = this.allinsti
          .filter(
            x =>
              x.name == this.retrievedquestion.category &&
              x.organization_name == this.org
          )
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(subbb);
      } else {
        categoryinstitution = this.retrievedquestion.institution;
        let subbb = this.allinsti
          .filter(x => x.name == this.retrievedquestion.institution)
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(subbb);
      }
    }

    this.attachmentfiles = this.retrievedquestion.image_link;
    this.solutionlink = this.retrievedquestion.solution;

    this.question = {
      institution: categoryinstitution,
      subject: this.retrievedquestion.subject,
      category: this.retrievedquestion.category,
      level: this.retrievedquestion.level,
      course: this.retrievedquestion.course,
      section: this.retrievedquestion.section,
      question: this.retrievedquestion.question,
      structure: this.retrievedquestion.structure,
      oeqanswer: this.retrievedquestion.oeq_answer,
      optionA: this.retrievedquestion.a,
      optionB: this.retrievedquestion.b,
      optionC: this.retrievedquestion.c,
      optionD: this.retrievedquestion.d,
      optionE: this.retrievedquestion.e,
      correct: this.retrievedquestion.correct,
      isSolution: this.retrievedquestion.isSolution,
      solutiontype: this.retrievedquestion.solutiontype,
      solution: this.retrievedquestion.solution,
      scholarshiptype: "",
      isAttachment: this.retrievedquestion.isAttachment,
      attachmentfile: this.retrievedquestion.image_link,
      trackid: this.retrievedquestion.track_id,
      isPassage: this.retrievedquestion.isPassage,
      passage: this.retrievedquestion.passage,
      topicref: this.retrievedquestion.topic_reference
    };
  },

  methods: {
    handleImage() {
      this.uploadingqimage = true;
      let ifile = this.$refs.file.files[0];
      this.imageUpload(ifile).then(() => {
        if (this.status == "success") {
          this.uploadingqimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.filelink = this.url;
          console.log(this.url);
          this.filelink = this.url;
          //console.log(response.data);
          this.setFile(this.url);
          this.attachmentfiles = this.url;
        }
      });
    },
    handleSolutionimage() {
      this.uploadingqimage = true;
      let ifile = this.$refs.sfile.files[0];

      this.imageUpload(ifile).then(() => {
        if (this.status == "success") {
          this.uploadingqimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.solutionlink = this.url;
        }
      });
    },
    handleInlineImage() {
      this.uploadinginlineimage = true;
      let ifile = this.$refs.inlinefile.files[0];
      this.imageUpload(ifile).then(() => {
        if (this.status == "success") {
          this.uploadinginlineimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.$bvModal.show("inlinemodal");
          this.filelink = this.url;
          // console.log(this.url);
          //this.setFile(response.data.url);
          this.inlineattachmentfile = this.url;
          this.copytext = this.url;
        }
      });
    },
    async imageUpload(imagefile) {
      this.url = "";
      this.status = "";
      let formData = new FormData();
      formData.append("image", imagefile);
      formData.append("environment", this.environ);
      formData.append("origin", this.origin);
      formData.append("pretag", "questionimage");
      let apilink =
        this.environ == "development"
          ? `${this.origin}/ImageHandler.php`
          : `${this.origin}/ImageHandler.php`;

      return await axios
        .post(apilink, formData, {
          header: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.uploadingqimage = false;
          this.url = response.data.url;
          this.status = "success";
        })
        .catch(() => {
          this.status = "error";
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          //console.log(error);
        });
    },

    leaveRoute() {
      this.leaving = true;
      this.$bvToast.toast("Press the Back Button again to Exit", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },
    stayRoute() {
      this.$bvToast.toast("Exiting Canceled", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },

    chgCourses() {
      this.question.course = null;
      // Get the Whole Config Object of the selected Undergraduate Institution
      let levell = this.allinsti
        .filter(
          x =>
            x.category == this.question.category &&
            x.name == this.question.institution
        )
        .map(x => x.levels_config);

      let reallevell = JSON.parse(levell);

      // Get the Chosen Level exact config Array
      let config = reallevell
        .filter(x => x.name == this.question.level)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config[0]
        .filter(x => x.name == "courses")
        .map(x => x.values);

      // Inject this Array into the general courses Array for Selection
      this.coursesarray = courses[0];
    },
    chgSection() {
      this.question.section = null;
      // Get the Whole Config Object of the selected Undergraduate Institution
      let levell = this.allinsti
        .filter(
          x =>
            x.category == this.question.category &&
            x.name == this.question.institution
        )
        .map(x => x.levels_config);

      let reallevell = JSON.parse(levell);

      // Get the Chosen Level exact config Array
      let config = reallevell
        .filter(x => x.name == this.question.level)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let sections = config[0]
        .filter(x => x.name == "sectionsperc")
        .map(x => x.values);

      let courseindex = this.coursesarray.indexOf(this.question.course);
      let nsections = sections[0][courseindex];
      let sectarr = Array();

      for (let i = 0; i < nsections; i++) {
        let alpha = Array(
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K"
        );
        sectarr.push("Section " + alpha[i]);
      }

      this.sectionarray = sectarr;

      // console.log(sectarr)

      // Inject this Array into the general courses Array for Selection
      //this.sectionsarr = courses[0]
    },

    institutionChanged() {
      let tabi = this.allinsti
        .filter(
          x =>
            x.category == this.question.category &&
            x.name == this.question.institution &&
            x.organization_name == this.org
        )
        .map(x => x.structure);
      this.structure = tabi[0];

      if (this.structure == "Section") {
        let levell = this.allinsti
          .filter(
            x =>
              x.category == this.question.category &&
              x.name == this.question.institution
          )
          .map(x => x.levels_config);
        //console.log(JSON.parse(levell))
        let reallevell = JSON.parse(levell);

        this.levelarray = reallevell.map(x => x.name);
      } else {
        let subbb = this.allinsti
          .filter(
            x =>
              x.name == this.question.institution &&
              x.category == this.question.category
          )
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(subbb);
      }
    },
    categoryChanged() {
      this.question.institution = null; // If the type is changed, reset the select Object. set the institution property to null
      this.institutionsarray = []; // Empties the Institutions Array
      this.topicfor = null;

      let inst = this.allinsti
        .filter(
          x =>
            x.available == "Yes" &&
            x.category == this.question.category &&
            x.organization_name == this.org
        )
        .map(x => x.name);

      // console.log(inst)
      this.institutionsarray = inst;

      this.question.organization = this.org;
      // let tabi = this.Categories.filter(
      //     (x) => x.organization_name == this.org && x.name == this.question.category
      // ).map((x) => x.structure);
      // this.structure = tabi[0];

      let sameName = this.Categories.filter(
        x => x.organization_name == this.org && x.name == this.question.category
      ).map(x => x.sameName);
      this.sameName = sameName[0];

      if (this.sameName == "Yes") {
        this.question.institution = this.question.category;
        let subbb = this.allinsti
          .filter(
            x =>
              x.name == this.question.category &&
              x.organization_name == this.org
          )
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(subbb);
      }
      // let inst = this.allinsti.filter(x => x.available == "Yes" && x.category == this.question.category).map(x => x.name);
      // this.institutionsarrayay = inst;

      // if (this.question.category == "JAMB") {

      //     this.question.institution = "JAMB";

      //      // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
      //     let unparsedSubjects = this.allinsti.filter(x => x.name == this.question.institution && x.category == this.question.category).map(x => x.subjects_offered);

      //     this.subjectsarray = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectsarray' to it
      // }
    },

    setQuestion() {
      this.setloader();
      this.sent = true;
      //console.log(this.question);
      this.question.attachmentfile = this.filelink;
      if (this.question.solutiontype == "Image") {
        this.question.solution = this.solutionlink;
      }

      this.updateQuestion(this.question).then(() => {
        this.questionupdated = true;
        this.uploading = false;
        this.sent = false;
      });
    },
    getForm() {
      return {
        institution: null,
        subject: null,
        category: null,
        level: null,
        section: null,
        scholarshiptype: null,
        passage: "",
        isAttachment: "",
        structure: "MCQ",
        oeqanswer: "",
        attachmentlink: "",
        attachmentfile: "",
        question: "",
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        optionE: "",
        correct: null,
        isSolution: "No",
        solutiontype: null,
        solution: "",
        topicref: "",
        admin: this.$store.state.loginmaster.details.fullname,
        trackid: this.$store.state.loginmaster.details.trackid
      };
    },
    setloader() {
      this.uploading = true;
    },

    copylink() {
      var cop = document.getElementById("copier");
      cop.select();
      cop.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },

    copynow() {
      document.execCommand("copy");
    },

    ...mapActions("admin", ["updateQuestion", "setImageDirectory"]),
    ...mapActions("admin", ["chekquestion", "setUFile"])
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      retrievedquestion: state => state.admin.editquestion[0],
      allinsti: state => state.exam.allinstitutions,
      fileimage: state => state.admin.quimageurl,
      Categories: state => state.admin.Categories,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.api_origin
    }),
    leav() {
      return this.leaving;
    },
    empties() {
      if (
        this.question.optionA.length == 0 ||
        this.question.optionB.length == 0 ||
        this.question.optionC.length == 0 ||
        this.question.optionD.length == 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
}

.copyicon {
  cursor: pointer;
}

.copier {
  position: absolute;
  left: -9999px;
}

@media screen and (max-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 300px;
  }
}
</style>
